var map = {
	"./altramuces.svg": "7eb1",
	"./apio.svg": "5013",
	"./cacahuetes.svg": "18e9",
	"./crustaceos.svg": "ca0d",
	"./dioxido-azufre-sulfitos.svg": "4c66",
	"./frutos-cascara.svg": "b923",
	"./gluten.svg": "0016",
	"./huevos.svg": "e926",
	"./lacteos.svg": "7eb4",
	"./moluscos.svg": "8a5a",
	"./mostaza.svg": "31a6",
	"./pescado.svg": "789f",
	"./sesamo.svg": "5dda",
	"./soja.svg": "2051"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd1f";